import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { DashboardState } from "../shared/store/dashboard.state";
import { LearningObjectiveEvent } from "./../shared/model/events";
import {
  CitoApplicationModule,
  LearningObjective,
} from "./../shared/model/model";
@Component({
  selector: "app-learning-objective-view",
  styleUrls: ["learning-objective-view.component.scss"],
  templateUrl: "learning-objective-view.component.html",
  standalone: true,
  imports: [CommonModule],
})
export class LearningObjectiveViewComponent {
  @Input() learningObjective: LearningObjective;
  @Input() readOnly = true;
  @Output() selectLearningObjective =
    new EventEmitter<LearningObjectiveEvent>();
  @Input() selected = false;

  selectedCitoModule$: Observable<CitoApplicationModule>;

  constructor(private store: Store) {
    this.selectedCitoModule$ = this.store.select(DashboardState.citomodule);
  }

  domainIcons: any = {
    "meten & meetkunde": "./assets/domainicons/DomainIcons_3.svg",
    verhoudingen: "./assets/domainicons/DomainIcons_2.svg",
    getallen: "./assets/domainicons/DomainIcons_1.svg",
    verbanden: "./assets/domainicons/verbanden.svg",
    "meten & meetkunde_opdracht": "./assets/domainicons/DomainIcons_6.svg",
    verhoudingen_opdracht: "./assets/domainicons/DomainIcons_5.svg",
    getallen_opdracht: "./assets/domainicons/DomainIcons_4.svg",
    verbanden_opdracht: "./assets/domainicons/verbanden_opdracht.svg",
  };

  domainabbreviations: any = {
    "meten & meetkunde": "MT",
    verhoudingen: "VH",
    getallen: "GT",
    verbanden: "VB",
    werkwoorden: "WW",
    weetwoorden: "WTW",
    regelwoorden: "RW",
    klankwoorden: "KW",
  };

  public learningObjectiveSelected = () =>
    this.selectLearningObjective.emit({
      learningObjectiveId: this.learningObjective.id,
      learningObjectiveCode: this.learningObjective.code,
    });

  public stripDescription = (description: string): string => {
    if (!description) return description;
    const index = description.indexOf('- niveau gr');
    return index !== -1 ? description.substring(0, index).trim() : description;
  };

  public getAbbreviation = (d: LearningObjective) =>
    this.domainabbreviations[d.domainTitle.toLowerCase()];

  public getNumber = (learningObjective: LearningObjective) => {
    const firstTenCharacters = learningObjective.subjectCode.slice(0, 10);

    if (!firstTenCharacters.includes("-")) return;

    const numberString = firstTenCharacters.split("-").reverse().pop();

    return numberString ? numberString.trim() : undefined;
  };
}
